<section class="pb-7">
  @if (filters(); as filters) {
    <div class="desk:centered-with-padding no-scrollbar flex w-screen overflow-x-auto px-5 pb-7">
      <app-filter-toggle-group [filters]="filters" [filterName]="filterName" />
    </div>
  }
  @if (furnitures(); as furnitures) {
    <div class="centered-with-padding grid grid-cols-1 gap-y-3 desk:grid-cols-3 desk:gap-5">
      @for (furniture of furnitures; track $index) {
        <div class="h-[273px]">
          <app-option-card
            [image]="furniture.image"
            (imageClicked)="openVisualFullScreenModal(furniture.image)"
            imageCursorType="zoomIn">
            <div card-title-left>{{ furniture.title }}</div>
          </app-option-card>
        </div>
      }
    </div>
  } @else {
    <app-grid-skeleton
      gridClass="centered-with-padding grid grid-cols-1 gap-y-3 desk:grid-cols-3 desk:gap-5"
      itemClass="h-[273px]"
      [count]="8" />
  }
  <div class="centered-with-padding">
    @if (data.infoText; as infoText) {
      <div class="mt-5 flex items-center gap-x-4 rounded-2xl bg-gray-light p-4 desk:w-fit">
        <div class="flex size-5 shrink-0 items-center justify-center rounded-md bg-purple">
          <app-svg [height]="20" [width]="20" src="assets/icons/info.svg" />
        </div>
        <span>{{ infoText }}</span>
      </div>
    }

    <div class="grid grid-cols-[auto_1fr] items-center gap-x-4 py-16 desk:gap-x-10 desk:px-28 desk:py-14">
      <app-svg [height]="161" [src]="data.iconText.icon.svg" [width]="136" class="block -rotate-3" />
      <app-title [title]="{ text: data.iconText.text, as: 'span' }" size="h2" />
    </div>
  </div>
</section>
